// extracted by mini-css-extract-plugin
export default {"container":"click-and-collect-search_container__95132"};